<script>
  import notify from "../../../../../Script/notify"
  import BadgeState from "../../Stores/badgeState"
  import Layers from "./layers.svelte"
  import Layerdelete from "../../../File/Edit/modules/layerDelete/index.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Boolean} - whether to show a draggable arrange nav or not
   */
  let showDragNavItem = false

  /**
   * @type {Number} - event clint y value stroed here
   */
  let mouseYCoordinate = null // pointer y coordinate within client

  /**
   * @type {Object} - draggable nav list data stored
   */
  let draggingItem = null

  /**
   * @type {Object} - draggable nav list ID stored
   */
  let draggingItemId = null

  /**
   * @type {Object} - draggable nav Index stored
   */
  let draggingItemIndex = null

  /**
   * @type {Object} - hovered nav Index stored
   */
  let hoveredItemIndex = null

  /**
   * @type {Object}- notification stored here
   */
  let notification = {
    close() {},
  }

  /**
   * @description function for home list position retained in priority lisrt
   */
  let deleteSingleLayer = false
  let LayerDeleteObj = {}

  const rearrangeHomeNav = () => {
    ;[$BadgeState.operations[draggingItemIndex], $BadgeState.operations[hoveredItemIndex]] = [$BadgeState.operations[hoveredItemIndex], $BadgeState.operations[draggingItemIndex]]

    // balance
    draggingItemIndex = hoveredItemIndex
  }

  const clickToScrollView = (id) => {
    document.getElementById(id).scrollIntoView(true)
  }

  const showActiveComponent = (id, active, type) => {
    $BadgeState.operations = $BadgeState.operations.map((operation) => {
      operation.active = false

      if (active) {
        operation.active = false
        // $BadgeState.footer = "GENERAL" // Ensure footer updates when active is true
      } else {
        operation.active = operation.id == id

        if (type == "text") $BadgeState.footer = "TEXT"
        else if (type == "shape") $BadgeState.footer = "SHAPE"
        else if (type == "image") $BadgeState.footer = "IMAGE"
        else $BadgeState.footer = "RIBBON"
      }

      return operation
    })
  }

  const deleteLayer = (id, value) => {
    notification.close()
    $BadgeState.operations = $BadgeState.operations.filter((operation) => operation.id !== id)
    notification = notify.info(`${value || "Untitled layer"} Deleted Successfully!`)
    deleteSingleLayer = false
  }
</script>

<!-- 160 -->

{#if mouseYCoordinate}
  <div class="absolute z-10 w-full pr-7" style="top: {mouseYCoordinate + 12}px;user-select: none;">
    <div id="soul" class="flex w-full cursor-pointer items-center justify-between rounded-md bg-extraBlue-600 p-2 pr-3 hover:bg-extraBlue-500">
      <div class="flex items-center gap-3">
        <button class="flex h-10 w-10 cursor-all-scroll items-center justify-center rounded-md bg-extraBlue-600 text-white">
          <i class="fa-solid fa-grip-dots-vertical" />
        </button>

        <div class="max-w-[250px] truncate pl-6 text-lg font-medium tracking-wide text-white">{draggingItem.value}</div>
      </div>

      <button data-tooltip="Delete" tooltip-position="left" class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-white hover:bg-extraBlue-600">
        <i class="fa-solid fa-trash-can" />
      </button>
    </div>
  </div>
{/if}

<div class="space-y-3 overflow-x-hidden overflow-y-scroll">
  {#each $BadgeState.operations as operation, index (operation.id)}
    <!-- svelte-ignore a11y-mouse-events-have-key-events -->
    <div id={operation.id} class="space-y-3 pr-2">
      <Layers
        bind:LayerDeleteObj
        bind:deleteSingleLayer
        bind:operation
        on:click={() => {
          dispatch("changeShape", operation)
        }}
      >
        <!-- svelte-ignore a11y-click-events-have-key-events -->

        <!-- slot content -->
        <div
          on:click={() => {
            showActiveComponent(operation.id, operation.active, operation.type)
            clickToScrollView(operation.id)

            try {
              if (!operation.value) throw `Layer Title Can't be empty`
            } catch (error) {
              notification.close()
              const info = "PAGE: Badge Template Editor (Layers)\nEVENT: While validating Layer title"
              notification = notify.danger(error, info)
            }
          }}
          class="{draggingItemId == operation.id ? 'opacity-0' : 'bg-[#292A2F]'} flex w-full cursor-pointer {operation.active ? 'bg-extraBlue-600' : 'border-transparent'} {!operation.value.trim() ? 'bg-yellow-500 hover:bg-yellow-600' : ''} items-center justify-between rounded-md bg-[#202124] p-2 hover:bg-extraBlue-500"
        >
          <div class="flex items-center gap-3">
            <!-- svelte-ignore a11y-mouse-events-have-key-events -->
            <button
              data-tooltip="Move"
              tooltip-position="right"
              draggable={draggingItemId == operation.id ? false : true}
              on:dragstart={(e) => {
                const invisibleImage = document.createElement("img")
                invisibleImage.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                e.dataTransfer.setDragImage(invisibleImage, 0, 0)

                mouseYCoordinate = e.clientY

                draggingItem = operation
                draggingItemIndex = index
                draggingItemId = operation.id
                // distanceTopGrabbedVsPointer = e.target.getBoundingClientRect().y - e.clientY

                $BadgeState.operations = $BadgeState.operations.map((operation) => {
                  operation.active = false
                  return operation
                })
              }}
              on:drag={(e) => {
                mouseYCoordinate = e.clientY
              }}
              on:dragover={(e) => {
                hoveredItemIndex = index
                rearrangeHomeNav()
              }}
              on:dragend={(e) => {
                draggingItemId = null // makes item visible
                hoveredItemIndex = null // prevents instant swap
                mouseYCoordinate = null // prevents instant swap
              }}
              class="flex h-10 w-10 cursor-all-scroll items-center justify-center rounded-md text-white hover:bg-extraBlue-600"
            >
              <i class="fa-solid fa-grip-dots-vertical" />
            </button>

            <div class="max-w-[250px] select-none truncate text-lg font-medium tracking-wide text-white">
              {operation.value}
            </div>
            <div>
              {#if !operation.value}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="h-8 w-8">
                  <!-- Background Triangle -->
                  <path fill="#FF0000" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32z" />
                  <!-- Exclamation Mark -->
                  <path fill="#ffffff" d="M256 160c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24v-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
                </svg>
              {/if}
            </div>
          </div>
          <button
            on:click|stopPropagation={() => {
              if (operation.value != "Click to verify") {
                operation.value = operation.value.trim()
                LayerDeleteObj = { value: operation.value, id: operation.id }
                deleteSingleLayer = true
              } else {
                notification.close()
                const info = "PAGE: Badge Template Editor (Layers)\nEVENT: While deleting layer"
                notification = notify.danger("You Can't delete this layer as it is mandatory.", info)
                return
              }
            }}
            data-tooltip="Delete"
            tooltip-position="left"
            class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-white hover:bg-extraBlue-600"
          >
            <i class="fa-solid fa-trash-can" />
          </button>
        </div>
      </Layers>
    </div>
  {/each}
</div>

{#if deleteSingleLayer}
  <Layerdelete
    on:deleteLayer={() => deleteLayer(LayerDeleteObj.id, LayerDeleteObj.value)}
    on:click={() => {
      deleteSingleLayer = false
    }}
    attribute={LayerDeleteObj.value || "Untitled"}
  />
{/if}

<!-- on:click={() => deleteLayer(operation.id, operation.value)} -->
